var render = function (_h,_vm) {var _c=_vm._c;return _c(_vm.injections.components.ZenEllipsis,{tag:"component"},_vm._l((_vm.props.data),function(option){return _c('div',{key:option.name},[_vm._v(_vm._s(option.name)+": "+_vm._s(option.value))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }